/**
 * Set footer position
 */
function placeFooter() {
    if ($('body').hasClass('content-page')) return;

    var $logo = $('.logo');
    var $introText = $('.intro-text');
    var $footer = $('.footer');
    var $images = $('.images');

    var windowHeight = $(window).height();
    var placeLeft = windowHeight - $logo.height() - $introText.outerHeight();

    if ($images.hasClass('hidden')) {
        if (placeLeft > 200) {
            $footer.css('padding-top', placeLeft - 200);
        } else {
            $footer.css('padding-top', 0);
        }
    }
}

// Set footer position on start and resize
$(document).ready(placeFooter);
$(window).resize(placeFooter);

/**
 * Start animation
 */
$(function () {

    /**
     * Start page or content page?
     */
    if ($('body').hasClass('content-page')) {
        showContentPage();
    } else {
        startAnimation();
    }

    /**
     * Show content page
     */
    function showContentPage() {

        // Cache selectors
        var $content = $('.content');
        var $logo = $content.find('.logo');
        var $footer = $('.footer');
        var $footerLogo = $footer.find('.text-logo');
        var $footerContent = $footer.find('.inner');

        // Show elements
        $logo.css('opacity', 1);
        $footerLogo.css('opacity', 1);
        $footerContent.css('opacity', 1);
    }

    /**
     * Start page animation
     */
    function startAnimation() {
        var delay = void 0,
            speed = void 0;

        // Cache selectors
        var $startLogo = $('.logo-start');
        var $content = $('.content');
        var $logo = $content.find('.logo');
        var $footer = $('.footer');
        var $footerLogo = $footer.find('.text-logo');
        var $footerContent = $footer.find('.inner');
        var $introPart1 = $content.find('.part-1');
        var $introPart2 = $content.find('.part-2');
        var $introPart3 = $content.find('.part-3');
        var $images = $('.images');

        // Start logo
        delay = 2000;
        speed = 1000;
        setTimeout(function () {
            $startLogo.animate({ opacity: 0 }, speed, function () {
                $startLogo.remove();
            });
        }, delay);

        // Content logo
        delay = delay + speed - 500;
        speed = 1500;
        setTimeout(function () {
            $logo.animate({ opacity: 1 }, speed);
        }, delay);

        // Footer text logo
        delay = delay + 500;
        speed = 1000;
        setTimeout(function () {
            $footerLogo.animate({ opacity: 1 }, speed);
        }, delay);

        // Intro part 1
        delay = delay + 500;
        speed = 500;
        setTimeout(function () {
            $introPart1.animate({ opacity: 1 }, speed);
        }, delay);

        // Intro part 2
        delay = delay + 500;
        speed = 500;
        setTimeout(function () {
            $introPart2.animate({ opacity: 1 }, speed);
        }, delay);

        // Intro part 3
        delay = delay + 500;
        speed = 500;
        setTimeout(function () {
            $introPart3.animate({ opacity: 1 }, speed, function () {

                // Activate scrolling
                $('body').removeClass('no-scrolling');

                // Footer content
                setTimeout(function () {
                    $footerContent.animate({ opacity: 1 }, 1000);
                }, 1000);

                setTimeout(function () {
                    $images.removeClass('hidden').hide().css({
                        'height': 'auto'
                    }).animate({
                        height: 'toggle',
                        opacity: 1
                    }, 1500, 'easeOutQuad');

                    $footer.animate({
                        'padding-top': 0
                    }, 1500, 'easeOutQuad');
                }, 3000);
            });
        }, delay);
    }
});

// Scroll to on start
$(window).on('load', function () {
    $('html,body').animate({
        scrollTop: 0
    }, 1);
});